<template>
	<div class="rec-main__app">
		<div class="session-wrapper container">
			<template v-if="!user.recorder">
				<p>Recorder is not assigned. Please contact your system administrator.</p>
			</template>
			<template v-else-if="!user.recorder.enabled">
				<p>Your account is partially disabled and you will not be able to perform any recording or live streaming activities.</p>
				<p>To fully enable your account, please contact our support organization.</p>
			</template>
			<template v-else>
				<session
					v-show="recorderState === 'READY'"
					ref="session"
					:user="user"
				/>
				<p v-if="recorderState === 'PENDING'">Your recorder is being provisioned. Please wait.</p>
				<ui-progress v-if="recorderState !== 'READY'" type="dots"/>
			</template>
		</div>

		<media-list
			v-if="user.recorder_id"
			ref="mediaList"
			class="media-list-wrapper container"
			:recorder-api-url="recorderApiUrl"
			:recorder-id="user.recorder_id"
		/>
	</div>
</template>

<script>
import MediaList from "components/media/List";
import Session from "components/session/Session";
import UiProgress from "lib/components/ui/Progress";

import alert from "lib/modules/Alert";
import http from "lib/modules/Http";

import parseISO from "date-fns/parseISO";

export default {
	name: "App",
	components: {
		MediaList,
		Session,
		UiProgress
	},
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			recorderState: "INIT"
		};
	},
	computed: {
		recorderApiUrl() {
			return `${location.protocol}//${this.user.recorder.server.hostname}/api/v2`;
		}
	},
	mounted() {
		if (!this.user.recorder || !this.user.recorder.enabled)
			return;

		this.mediaListUpdated = -1;

		this.checkLocationHash = () => {
			if (window.location.hash === "#!/action/create-stream")
				$bus.$emit("_stream/CreateDialog.open", this.user.recorder_id);
		};

		this.checkLocationHash();
		this.pollSessionStatus();

		window.addEventListener("hashchange", this.checkLocationHash, false);
		$bus.$on("_App.getSessionStatus", this.pollSessionStatus);
	},
	beforeDestroy() {
		window.removeEventListener("hashchange", this.checkLocationHash, false);
		$bus.$off("_App.getSessionStatus", this.pollSessionStatus);
		this.stopSessionStatus();
	},
	methods: {
		getSessionStatus() {
			http.get(`${this.recorderApiUrl}/recorder/${this.user.recorder_id}/sessionstatus`)
			.then((sessionStatus) => {
				this.recorderState = "READY";

				this.$refs.session.updateSessionList(sessionStatus.data.sessionlist);

				if (this.mediaListUpdated < sessionStatus.data.media_lastupdated) {

					if (this.mediaListUpdated >= 0)
						this.$refs.mediaList.getMediaList();

					this.mediaListUpdated = sessionStatus.data.media_lastupdated;
				}
			})
			.catch((error) => {
				if (!error.response) {
					alert.error("Unable to get session status");

					return;
				}

				const updatedTs = parseISO(this.user.recorder.updated).getTime();
				const responseTs = new Date(error.response.headers.date).getTime();

				if (responseTs - updatedTs < 120000)
					this.recorderState = "PENDING";
				else
					alert.error("Unable to get session status", error.response);
			});
		},
		pollSessionStatus() {
			this.stopSessionStatus();
			this.getSessionStatus();

			this.sessionStatusInterval = setInterval(() => {
				this.getSessionStatus();
			}, 3000);
		},
		stopSessionStatus() {
			clearInterval(this.sessionStatusInterval);
		}
	}
};
</script>

<style lang="scss" scoped>
	.session-wrapper {
		p {
			font-weight: bold;
			text-align: center;
		}
	}
	.media-list-wrapper {
		margin-top: 15px;
	}
</style>
